import React from "react"
import Helpers from "utils/Helpers"
import { CurrencyString } from "components/views/molecules/CurrencyString"
import { Spacer } from "components/views/atoms/Atoms"
import L10n from "lib/carrot-l10n"
import { H5 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const TableHeader = ({ children }) => (
  <th className="black-60 gotham ttu tl medium" style={{ fontSize: "11px" }}>
    {children}
  </th>
)

const UploadCardExpenseDetails = ({ submittedDatetime, amount }) => {
  return (
    <>
      <table>
        <thead>
          <TableHeader>{l`client.reimbursements.transactionDate`}</TableHeader>
          <TableHeader>{l`client.reimbursements.amount`}</TableHeader>
        </thead>
        <tbody>
          <tr>
            <td>
              <div style={{ minWidth: "10rem" }}>
                <H5>{Helpers.formatDate(submittedDatetime)}</H5>
              </div>
            </td>
            <td>
              <H5>
                <CurrencyString amount={amount} />
              </H5>
            </td>
          </tr>
        </tbody>
      </table>
      <Spacer height={1} />
    </>
  )
}

export { UploadCardExpenseDetails }
